import { PositionService } from './position-service';

/**
 * @typedef {import('./tooltip-service-types.d.ts').TooltipPositionValues} TooltipPositionValues
 */

/**
 * @type {Record<string, TooltipPositionValues>}
 */
export const TOOL_TIP_POSITIONS = {
  top: 'top',
  topRight: 'top-right',
  rightTop: 'right-top',
  right: 'right',
  rightBottom: 'right-bottom',
  bottomRight: 'bottom-right',
  bottom: 'bottom',
  bottomLeft: 'bottom-left',
  leftBottom: 'left-bottom',
  left: 'left',
  leftTop: 'left-top',
  topLeft: 'top-left',
};

class TooltipServiceClass {
  constructor() {
    this.tooltipZIndex = 100;
  }

  getStyleAndArrowClass(position, boundingBox) {
    return {
      arrowClass: this.getArrowClass(position),
      style: PositionService.getStyleFromBoundingBox(position, boundingBox, this.getValidPositions()),
    };
  }

  getArrowClass(position) {
    if (!position) {
      return 'down';
    }
    if (position.startsWith('bottom')) {
      return 'up';
    }
    if (position.startsWith('right')) {
      return 'left';
    }
    if (position.startsWith('left')) {
      return 'right';
    }
    return 'down';
  }

  getValidPositions() {
    return [
      'top',
      'top-right',
      'right-top',
      'right',
      'right-bottom',
      'bottom-right',
      'bottom',
      'bottom-left',
      'left-bottom',
      'left',
      'left-top',
      'top-left',
    ];
  }

  getNextPosition(currentPosition) {
    return PositionService.getNextPosition(currentPosition, this.getValidPositions());
  }
}

export const TooltipService = new TooltipServiceClass();
